import React from 'react'
import CategoriesList from '../components/categories-list'
import Header from '../components/header'
import Footer from '../components/footer'
import './categories.scss'
import jump from 'jump.js'
import slugify from 'slugify'

class Categories extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const header = document.getElementsByClassName('header')[0];
    header.classList += ' unfix';
    const logo = document.getElementsByClassName('logo')[0];
    logo.classList.remove('fade-down');

    const hash = this.props.location.hash;

    if (hash) {
      setTimeout(function() {
        jump(`${hash}`, {
          duration: 600,
          offset: -5
        })
      }, 300)
    }

    this.fadeInContent()
  }

  componentWillUnmount() {
    const header = document.getElementsByClassName('header')[0];
    header.classList.remove('unfix');
    this.fadeOutContent()
  }

  render() {
    const activeCat = this.props.location.hash.split('#')[1];

    return (
      <div className="main-wrapper categories">
        <CategoriesList
          {...this.props}
          activeCategory={activeCat}
          allData={this.props.data.allContentfulCategory.edges}
          handleClick={this.handleClick.bind(this)} />

        <Footer footerData={this.props.data.contentfulFooter} />
      </div>
    )
  }

  fadeInContent() {
    const wrapper = document.getElementById('content-wrapper');
    setTimeout(function() {
      wrapper.classList += ' visible';
    }, 600)
  }

  fadeOutContent() {
    const wrapper = document.getElementById('content-wrapper');
    if (wrapper.classList.contains('visible')) {
      wrapper.classList.remove('visible');
    }
  }

  handleClick(name){
    const {history} = this.props;
    const slug = slugify(name, { lower: true })
    const el = document.getElementById(slug);

    if (history.location.hash === `#${slug}`) {
      history.replace(`/categories`)
    } else {
      history.push(`#${slug}`)
      setTimeout(function() {
        jump(`#${slug}`, {
          duration: 600,
          offset: -5
        })
      }, 300)
    }
  }
}

export default Categories

export const pageQuery = graphql`
  query catQuery {
    allContentfulCategory (limit: 100) {
      edges {
        node {
          id
          name
          description {
            childMarkdownRemark {
              html
            }
          }
          orderNumber
          projects {
            ...ProjectsPerCategory
          }
        }
      }
    }
    contentfulFooter {
      description {
        childMarkdownRemark {
          html
        }
      }
      contactInformation {
        childMarkdownRemark {
          html
        }
      }
    }
  }
  fragment ProjectsPerCategory on ContentfulProject {
    title
    slug
    shortDescription
    imageThumbnail {
      file {
        url
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/categories.js